import React from 'react';

// Desktop Share App — the two QR codes side by side, ready to show on screen or print.
export default function ShareAppDesktop({ vm }) {
  const { links, copy, open, whatsapp, download } = vm;
  return (
    <div>
      <div className="page-head">
        <h1>Share App</h1>
        <span className="muted">Let others scan to open Mehfil</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 14, maxWidth: 820 }}>
        {links.map(link => (
          <div key={link.key} className="card card-pad share-qr-card">
            <strong style={{ fontSize: 16 }}>{link.title}</strong>
            <div className="share-qr-box">
              {link.qr ? <img src={link.qr} alt={`QR code: ${link.url}`} /> : <span className="muted">Drawing…</span>}
            </div>
            <div className="muted" style={{ fontSize: 13 }}>{link.hint}</div>
            <a className="share-qr-url" href={link.url} target="_blank" rel="noreferrer">{link.url}</a>
            <div className="share-qr-actions">
              <button className="btn" onClick={() => copy(link)}>Copy link</button>
              <button className="btn" onClick={() => whatsapp(link)}>WhatsApp</button>
              <button className="btn" onClick={() => download(link)} disabled={!link.qr}>Download QR</button>
              <button className="btn" onClick={() => open(link)}>Open</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
